import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import settingsService, {
  IConfigureIntegrationRequest,
} from "api/settingsService";
import { ENotificationType, notification } from "utils/notification";
import HollowButton from "components/HollowButton";
import { IntegrationType } from "dto/Settings/IntegrationType";
import { IntegrationProvider } from "dto/Settings/IntegrationProvider";

const ConfigureAppleCalendar: FC<Props> = ({ onSuccess, toggle }) => {
  const { t } = useTranslation();
  const { mutate: integration, isLoading } =
    settingsService.useConfigureIntegration();

  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState<string>(null);

  const handleClick = () => {
    const payload: IConfigureIntegrationRequest = {
      Type: IntegrationType.Calendar,
      Provider: IntegrationProvider.Apple,
      AppleLogin: data.email,
      ApplePassword: data.password,
    };

    setError(null);
    integration(payload, {
      onSuccess: () => {
        onSuccess(data.email);
        toggle();
      },
      onError: (response: any) => {
        const name = response.response.data.errorCodes[0].message;

        notification({
          type: ENotificationType.ERROR,
          title: t("integrations.createIntegrationFailed"),
          text: name,
        });
        setError(name);
      },
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{t("integrations.configureAppleCalendarTitle")}</div>
      <div className={styles.body}>
        Aby była możliwa integracja konta iCloud z Notaup konieczne jest
        utworzenie hasła dla aplikacji. Możesz to zrobić w konfiguracji swojego
        konta Apple w zakładce{" "}
        <a href="https://account.apple.com/account/manage" target="_blank">
          Logowanie i zabezpieczenia
        </a>
      </div>
      <div className={styles.form}>
        <Input
          value={data.email}
          onChange={(t) => setData({ ...data, email: t })}
          label={t("forms.email")}
        />
        <Input
          value={data.password}
          type="password"
          onChange={(t) => setData({ ...data, password: t })}
          label={t("auth.appPassword")}
        />

        {error && <div className={styles.error}>{error}</div>}
        <div className={styles.buttonsWrapper}>
          <HollowButton text={t("common.cancel")} onClick={() => toggle()} />
          <Button
            text={t("common.save")}
            onClick={handleClick}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfigureAppleCalendar;
